import * as React from 'react'
import { ConfirmEmailMainConnected } from './ConfirmEmailMainConnected'
import { Provider } from 'react-redux'
import { mockState, createMockStore } from 'mockState'

export const ConfirmEmailMainExamples = () => {
  return (
    <div className="ConfirmEmailMainExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <ConfirmEmailMainConnected />
      </Provider>
    </div>
  )
}
